import { SmileyType, RatingString } from './types';

export const getSmileyRating = (rating: number) => {
  if (rating <= 1) {
    return {
      iconType: SmileyType.ANGRY,
      text: RatingString.terrible,
    };
  }

  if (rating <= 2) {
    return {
      iconType: SmileyType.DISSATISFIED,
      text: RatingString.bad,
    };
  }

  if (rating <= 3) {
    return {
      iconType: SmileyType.NEUTRAL,
      text: RatingString.ok,
    };
  }

  if (rating <= 4) {
    return {
      iconType: SmileyType.SMILING,
      text: RatingString.good,
    };
  }

  if (rating > 4) {
    return {
      iconType: SmileyType.LAUGHING,
      text: RatingString.excellent,
    };
  }

  return null;
};
